import { ChevronRight } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconAngleRight(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <ChevronRight />
    </IconWrapper>
  );
}
